// Display timezone for the whole app. Configurable via VITE_DISPLAY_TIMEZONE.
export const DISPLAY_TIMEZONE = import.meta.env?.VITE_DISPLAY_TIMEZONE || 'Europe/Kyiv';

const dayFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: DISPLAY_TIMEZONE,
  year: 'numeric', month: '2-digit', day: '2-digit',
});

const timeFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: DISPLAY_TIMEZONE,
  hour: '2-digit', minute: '2-digit', hour12: false,
});

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.000)?Z?)?$/;

// 'YYYY-MM-DD' in DISPLAY_TIMEZONE from an ISO string or Date.
// A date-only string ('YYYY-MM-DD' or midnight-UTC) is kept as-is so birthdays don't drift.
export const fmtTzDate = (value) => {
  if (value == null) return '';
  const s = String(value);
  const m = s.match(DATE_ONLY_RE);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return dayFormatter.format(d);
};

// 'HH:mm' in DISPLAY_TIMEZONE, or undefined for 00:00 / invalid.
export const fmtTzTime = (value) => {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return undefined;
  const hhmm = timeFormatter.format(d);
  return hhmm && hhmm !== '00:00' ? hhmm : undefined;
};

// Human-readable date in DISPLAY_TIMEZONE, e.g. "24 Jul 2026".
export const fmtTzDateHuman = (value, options = { day: '2-digit', month: 'short', year: 'numeric' }) => {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
  return d.toLocaleDateString('en-US', { timeZone: DISPLAY_TIMEZONE, ...options });
};

// Human-readable date + time in DISPLAY_TIMEZONE, e.g. "24 Jul 2026, 14:30".
export const fmtTzDateTimeHuman = (value, options = {
  year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
}) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
  return d.toLocaleString('en-US', { timeZone: DISPLAY_TIMEZONE, ...options });
};
